import { Box, Button, HStack, Text } from "@chakra-ui/react";
import React from "react";

import { useLandingPage } from "../../hooks/useLandingPage";

/**
 * Profile Tabs Component
 * Matches the design with Profile heading and pill-style tab container
 */
export default function ProfileTabs({ activeTab, onTabChange }) {
  const { tabConfig } = useLandingPage();

  return (
    <Box
      w="100%"
      bg="gray.50"
      px={{ base: 4, md: 8, lg: 12 }}
      pt={4}
      pb={3}
    >
      {/* Tab Navigation Container */}
      <Box display="flex" justifyContent="center" w="100%">
        <Box
          border="1px solid"
          borderColor="gray.200"
          borderRadius="full"
          px={1.5}
          py={1}
          bg="white"
          shadow="md"
          w="fit-content"
        >
          <HStack spacing={0}>
            {tabConfig.map((tab, index) => {
              const isActive = activeTab === index;

              return (
                <HStack key={index} spacing={0}>
                  <Button
                    variant="unstyled"
                    onClick={() => onTabChange(index)}
                    bg={isActive ? "orange.50" : "transparent"}
                    color={isActive ? "gray.900" : "gray.600"}
                    _hover={{
                      bg: isActive ? "orange.50" : "gray.50",
                      color: "gray.900",
                    }}
                    _focus={{
                      boxShadow: "none",
                    }}
                    _active={{
                      transform: "scale(0.98)",
                    }}
                    transition="all 0.2s ease"
                    fontWeight={isActive ? "600" : "500"}
                    px={8}
                    py={2.5}
                    fontSize="sm"
                    borderRadius="full"
                    minW="160px"
                    h="38px"
                    position="relative"
                    whiteSpace="nowrap"
                    // Orange underline for active tab
                    _after={isActive ? {
                      content: '""',
                      position: "absolute",
                      bottom: "6px",
                      left: "50%",
                      transform: "translateX(-50%)",
                      w: "50%",
                      h: "3px",
                      bg: "orange.500",
                      borderRadius: "full",
                    } : undefined}
                  >
                    {tab.label}
                  </Button>

                  {/* Vertical divider between tabs */}
                  {index < tabConfig.length - 1 && (
                    <Box
                      mx={2}
                      w="1px"
                      h="24px"
                      bg="gray.200"
                    />
                  )}
                </HStack>
              );
            })}
          </HStack>
        </Box>
      </Box>
    </Box>
  );
}
